export function getBoundingClientRect(element: HTMLElement | SVGElement): DOMRect {
    //IE/Edge don't know the x and y property: https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
    const rect = element.getBoundingClientRect();
    if (rect.x === undefined) rect.x = rect.left;
    if (rect.y === undefined) rect.y = rect.top;

    return rect;
}
